import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

// AUTH-01 closure — MFA Success (rendered inside StandaloneShell)
export default function MfaSuccessPage() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const t = setInterval(() => setCountdown((c) => c - 1), 1000);
    const r = setTimeout(() => navigate("/member/account"), 5000);
    return () => { clearInterval(t); clearTimeout(r); };
  }, [navigate]);

  return (
    <div className="text-center space-y-6">
      <div className="mx-auto size-14 rounded-full bg-emerald-50 grid place-items-center">
        <div className="size-12 rounded-full bg-emerald-100 grid place-items-center">
          <ShieldCheck className="size-6 text-emerald-700" strokeWidth={2.2} />
        </div>
      </div>
      <div>
        <div className="eyebrow text-emerald-700 mb-2">2FA enabled</div>
        <h1 className="font-brand text-h1 text-ink">You&rsquo;re extra protected.</h1>
        <p className="mt-3 text-body-sm text-ink-muted leading-relaxed">
          Two-factor authentication is now required for sign-in. We&rsquo;ll prompt for a code each time you log in from a new device.
        </p>
      </div>

      <div className="bg-surface-alt border border-line rounded-md p-4 text-left text-caption text-ink-muted leading-relaxed">
        <strong className="text-ink">Reminder:</strong> recovery codes work once each. Save them in a password manager &mdash;
        without them, losing your authenticator means contacting support to recover access.
      </div>

      <Button onClick={() => navigate("/member/account")}
              className="w-full h-11 bg-brand-700 hover:bg-brand-800 text-white" data-testid="mfa-success-continue">
        Continue to account <ArrowRight className="size-4 ml-2" />
      </Button>
      <p className="text-caption text-ink-subtle">
        Auto-redirecting in <span className="tabular-nums font-semibold text-ink">{Math.max(0, countdown)}s</span>
      </p>
    </div>
  );
}
